<script>
import WelfareCard from './WelfareCard'
export default {
  components: {
    WelfareCard,
  },
  props: {
    aboutCompany: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeName: 'first',
      text: '為了吸引、激勵及留住優秀人才，零壹提供完善的福利，滿足員工各方面的需求。',
      bonusList: {
        title: '獎金保險',
        list: [],
      },
      welfareList: {
        title: '福利補助',
        list: [],
      },
      holidayList: {
        title: '休假制度',
        list: [],
      },
      healthList: {
        title: '健康休閒',
        list: [],
      },
    }
  },
  created() {
    const vm = this
    vm.bonusList.list = this.aboutCompany.bonus.split('\n')
    vm.welfareList.list = this.aboutCompany.support.split('\n')
    vm.holidayList.list = this.aboutCompany.vacation.split('\n')
    vm.healthList.list = this.aboutCompany.health.split('\n')
  },
}
</script>
<template>
  <div :class="$style.welfare">
    <div class="welfare__box">
      <div class="container bg-overly">
        <div class="welfare-box">
          <BaseSectionTitle title="完善福利" class="text-center" />
          <p class="detail">{{ text }}</p>
          <el-tabs v-model="activeName" :stretch="true">
            <el-tab-pane label="獎金保險" name="first">
              <WelfareCard :data-list="bonusList"></WelfareCard>
            </el-tab-pane>
            <el-tab-pane label="福利補助" name="second">
              <WelfareCard :data-list="welfareList"></WelfareCard>
            </el-tab-pane>
            <el-tab-pane label="休假制度" name="third">
              <WelfareCard :data-list="holidayList"></WelfareCard>
            </el-tab-pane>
            <el-tab-pane label="健康休閒" name="fourth">
              <WelfareCard :data-list="healthList"></WelfareCard>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.welfare {
  background: $color-gray-2;
  margin-top: 70px;
  :global {
    .welfare {
      &__box {
        .container {
          .welfare-box {
            padding-top: 70px;
            padding-bottom: 70px;
            .detail {
              margin-bottom: 60px;
              font-size: 1.125rem;
              color: $color-gray-6;
              text-align: center;
            }
            .el-tabs__header {
              margin: 0 0 58px;
            }
            .el-tabs__item {
              font-size: 18px;
              margin-bottom: 20px;
            }
            .is-top {
              color: $color-gray-6;
            }
            .is-active {
              color: $color-primary;
            }
            @include max-md {
              padding: 40px 10px;
              .detail {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>